
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/releaselog",
      function () {
        return require("private-next-pages/releaselog.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/releaselog"])
      });
    }
  